import {
    GET_DEVICES_ERROR,
    GET_DEVICES_START,
    GET_DEVICES_SUCCESS,
} from '../../actions/actionTypes';
import initialState from '../initialState';

export default (state = initialState.devices.data, action = {type: ''}) => {
    switch (action.type) {
        case GET_DEVICES_START:
            return {
                ...state,
                error: false,
                loading: true,
            };
        case GET_DEVICES_SUCCESS:
            return {
                ...state,
                list: action.payload,
                loading: false,
            };
        case GET_DEVICES_ERROR:
            return {
                ...state,
                error: true,
                loading: false,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/deviceReducer/getDevicesReducer.js